/**
 * Wiederholungsstrategie fuer react-query.
 *
 * Hintergrund: Die Rolle `authenticated` bricht Abfragen nach 15 Sekunden ab
 * (SQLSTATE 57014). Mit der bisherigen Einstellung (bis zu zwei
 * Wiederholungen) wurde daraus das Schlimmste aus beiden Welten: Der Nutzer
 * sah knapp eine Minute lang einen Ladekreis, und jede Wiederholung belegte
 * weitere 15 Sekunden eine Datenbankverbindung.
 *
 * Bei M&M Hairdesign liefen so am 28.09.2026 innerhalb von 24 Stunden 730
 * Timeouts auf. Weil der Verbindungspool geteilt ist, bekamen dadurch auch
 * andere Salons 503er -- die Wiederholungen haben die Ueberlastung also aktiv
 * verstaerkt.
 *
 * Ein Timeout ist kein Wackler: Dieselbe Abfrage laeuft beim naechsten Versuch
 * genauso in die Bremse. Deshalb wird darauf gar nicht mehr gewartet, sondern
 * sofort ein Fehler gemeldet -- den die Oberflaeche jetzt auch anzeigen kann.
 */

/** PostgreSQL: query_canceled -- hier immer der 15s-Timeout der Rolle. */
export const STATEMENT_TIMEOUT_CODE = '57014';

/** Maximale Wiederholungen fuer Fehler, die tatsaechlich voruebergehend sein koennen. */
export const MAX_RETRIES = 1;

function readProperty(error: unknown, key: string): unknown {
  if (error && typeof error === 'object' && key in error) {
    return (error as Record<string, unknown>)[key];
  }
  return undefined;
}

/**
 * PostgREST-Fehler tragen den PostgreSQL-Code in `code`; manche Fehler aus dem
 * Supabase-Client tragen stattdessen einen HTTP-Status in `status`. Beides wird
 * beruecksichtigt, weil sonst je nach Fehlerquelle die falsche Entscheidung
 * fiele.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  const status = readProperty(error, 'status');
  if (status === 404 || status === 403) return false;

  const code = readProperty(error, 'code');
  if (code === STATEMENT_TIMEOUT_CODE) return false;

  return failureCount < MAX_RETRIES;
}
